import { useUser } from '../UserContext'
import UserLayout from './UserLayout'
import PublicLayout from './PublicLayout'

function DynamicLayout() {
  const { user } = useUser()
  const isLoggedIn = !!user.token

  return isLoggedIn ? <UserLayout /> : <PublicLayout />
}

export default DynamicLayout
